module.exports = __webpack_public_path__ + "img/pro_night_5.125f0f3b.jpg";